import '../../scss/components/_ambassadors-slider-widget.scss';

export class AmbassadorsSliderWidget {
    constructor (target) {
      this.section = target;
    }

    async init () {
      const { default: Swiper } = await import('swiper');
      const { Pagination } = await import('swiper/modules');

      await import('swiper/css');
      await import('swiper/css/pagination');

      const config = {
        slidesPerView: 1.2,
        spaceBetween: 16,
        enabled: true,
        a11y: {
          slideRole: 'presentation',
          slideLabelMessage: '',
        },
        breakpoints: {
          640: {
            spaceBetween: 16,
            slidesPerView: 2,
          },
          1200: {
            spaceBetween: 56,
            slidesPerView: 3,
          },
        },
        pagination: {
          el: this.section.querySelector('.swiper-pagination'),
          clickable: true
        },
        modules: [Pagination],
      };

      const sliderElement = this.section.querySelector('.swiper')

      new Swiper(sliderElement, config);
      this.loading(false);
    }

    loading(isLoading = true) {
        this.section.classList.toggle('loading', isLoading);
    }
}
